import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import { useAuth } from "./auth/authContext";
import NoAccess from "./NoAccess";

const withAuth = (WrappedComponent, options = {}) => {
  const { protectedRoute = true, requirePermission = true } = options;

  const Wrapper = (props) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAllowAccess, setIsAllowAccess] = useState(false);
    const { userData, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname, search } = location;
    const getMenuPermissions =
      _.find(
        userData?.module,
        (obj) =>
          obj.action === pathname + search ||
          _.some(obj.child, { action: pathname + search }),
      )?.permissions ?? "[]";
    const allowed_permissions = JSON.parse(getMenuPermissions);

    useEffect(() => {
      setIsAuthenticated(!!userData?.module);
      const allowed_access = _.filter(
        userData?.module,
        (obj) =>
          obj.action === pathname + search ||
          _.some(obj.child, { action: pathname + search }),
      );
      setIsAllowAccess(allowed_access?.length > 0);
      // setIsAllowAccess(true);

      if (protectedRoute && !loading && !userData) {
        navigate(`/signin`);
      } else if (!protectedRoute && !loading && userData) {
        navigate(-1);
      }
    }, [pathname, search, userData, loading]);

    return isAuthenticated === protectedRoute ? (
      <>
        {isAllowAccess || !protectedRoute || !requirePermission ? (
          <WrappedComponent
            {...props}
            allowed_permissions={allowed_permissions}
          />
        ) : (
          <NoAccess />
        )}
      </>
    ) : null;
  };

  return Wrapper;
};

export default withAuth;
